/* Product page shipping note: free-shipping progress (reads the cart). Threshold comes from the "Shipping zone" metaobject. */
(function () {
  var root = document.querySelector('[data-vvb-ship]');
  if (!root) return;
  var t = {};
  try { t = JSON.parse(root.querySelector('[data-vvb-ship-i18n]').textContent); } catch (e) {}
  var thr = parseFloat(root.getAttribute('data-thr')) || 0;
  var price = (parseInt(root.getAttribute('data-price'), 10) || 0) / 100;
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  var fmt;
  try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }); } catch (e) { fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }
  var wrap = root.querySelector('[data-vvb-ship-meter]'), msg = root.querySelector('[data-vvb-ship-msg]');
  var bar = root.querySelector('.vvb-ship__bar'), ci = root.querySelector('[data-vvb-ship-cart]'), ii = root.querySelector('[data-vvb-ship-item]');
  if (!thr || !wrap) return;
  function meter(cartTotal) {
    var withItem = cartTotal + price;
    var cp = Math.min(100, cartTotal / thr * 100), wp = Math.min(100, withItem / thr * 100);
    ci.style.width = cp + '%'; ii.style.width = Math.max(0, wp - cp) + '%';
    bar.setAttribute('aria-valuenow', Math.round(wp));
    if (cartTotal >= thr) { msg.textContent = t.unlocked; msg.className = 'vvb-ship__msg is-done'; }
    else if (withItem >= thr) { msg.textContent = t.itemUnlocks; msg.className = 'vvb-ship__msg is-done'; }
    else { msg.textContent = String(t.more || '').replace('%s', fmt.format(thr - withItem)); msg.className = 'vvb-ship__msg'; }
    wrap.removeAttribute('hidden');
  }
  function loadCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      meter((c.items_subtotal_price != null ? c.items_subtotal_price : c.total_price) / 100);
    }).catch(function () { meter(0); });
  }
  loadCart();
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.product-buy-buttons--primary')) { setTimeout(loadCart, 1400); setTimeout(loadCart, 3500); } });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) loadCart(); });
  window.addEventListener('pageshow', loadCart);
})();
